import instance from "@/utils/require.js"

// 发货工单--分页查询
export function apiShipmentOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/search",
		method: "post",
		data
	})
}

// 交接工单
export function apiHandoverOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/handover",
		method: "post",
		data
	})
}

// 发货工单--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 发货工单--订单状态
export function apiShipmentStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/shipment_status",
		method: "post",
		data
	})
}

// 发货工单--新建发货工单
export function apiShipmentOrderAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add",
		method: "post",
		data
	})
}
export function apiShipmentOrderRemove(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/remove",
		method: "post",
		data
	})
}

// 工单详情--详情
export function apiShipmentOrderDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/detail",
		method: "post",
		data
	})
}
export function apiShipmentOrderRollbackExWarehouse(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/rollback_ex_warehouse",
		method: "post",
		data
	})
}
export function apiShipmentOrderUpload(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/upload",
		method: "post",
		data
	})
}
export function apiShipmentOrderAbortUpload(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/abort_upload",
		method: "post",
		data
	})
}

// 工单详情--修改发货数量
export function apiShipUpdateQuantity(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_quantity",
		method: "post",
		data
	})
}
export function apiShipUpdateDestination(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_destination",
		method: "post",
		data
	})
}

export function apiShipUpdateNotes(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_notes",
		method: "post",
		data
	})
}

// 工单详情--修改栈板规格
export function apiShipUpdatePalletQuantity(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_pallet_quantity",
		method: "post",
		data
	})
}

export function apiShipUpdateOrderNumber(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_order_number",
		method: "post",
		data
	})
}

export function apiReworkByShipmentOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/rework/by_shipment_order",
		method: "post",
		data
	})
}

// 工单详情--修改入库单号
export function apiShipUpdateSrmOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_srm_order_number",
		method: "post",
		data
	})
}

export function apiShipUpdateLotPo(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_lot_po",
		method: "post",
		data
	})
}

// 工单详情--修改物料编码
export function apiShipUpdatePartNum(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/update_part_num",
		method: "post",
		data
	})
}

// 产品列表--工单设备查询
export function apiShipmentOrderDevices(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/devices",
		method: "post",
		data
	})
}

// 产品列表--组装工单下拉
export function apiProductionOrders(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/production_orders",
		method: "post",
		data
	})
}

// 产品列表--包装工单下拉
export function apiCartonOrders(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/carton_orders",
		method: "post",
		data
	})
}

// 产品列表--导出箱标
export function apiShipExportCarton(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/export_carton",
		method: "post",
		data
	})
}

// 产品列表--导出栈板标
export function apiShipExportPallet(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/export_pallet",
		method: "post",
		data
	})
}

// 产品列表--导出发货单
export function apiShipmentOrderExport(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/export",
		method: "post",
		data
	})
}
// 产品列表--导出发货单
export function apiShipmentOrderDevicesExport(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/export_devices",
		method: "post",
		data
	})
}

// 产品列表--添加产品--根据包装工单
export function apiAddDeviceByCartonOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_carton_order",
		method: "post",
		data
	})
}

// 产品列表--添加产品--根据连续箱号
export function apiAddDeviceByIndex(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_index",
		method: "post",
		data
	})
}

// 产品列表--添加产品--根据零散箱号
export function apiAddDeviceByIndexes(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_indexes",
		method: "post",
		data
	})
}

// 产品列表--添加产品--根据栈板箱号
export function apiAddDeviceByPalletIndexes(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_pallet_indexes",
		method: "post",
		data
	})
}

// 产品列表--添加产品--根据栈板箱号
export function apiAddDeviceByPalletSns(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_pallet_sn",
		method: "post",
		data
	})
}

// 产品列表--添加产品--根据零散SN
export function apiAddDeviceBySN(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_sn",
		method: "post",
		data
	})
}
// 产品列表--添加产品--根据零散未包装的SN
export function apiAddWithoutPackagingSn(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_without_packaging_sn",
		method: "post",
		data
	})
}
// 产品列表-添加产品-根据扫描箱号SN
export function apiAddDeviceByCtn(data = {}){
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_ctn",
		method: "post",
		data
	})
}

// 产品列表-移除产品-移除箱号SN
export function apiRemoveDeviceBySn(data = {}){
	return instance({
		url: "/aim/api/v3/shipment_order/remove_device/by_sn",
		method: "post",
		data
	})
}

// 产品列表-移除产品-移除产品SN
export function apiRemoveDeviceByCtn(data = {}){
	return instance({
		url: "/aim/api/v3/shipment_order/remove_device/by_ctn",
		method: "post",
		data
	})
}

// 产品列表--添加产品--根据组装工单
export function apiAddDeviceByProductionOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_device/by_production_order",
		method: "post",
		data
	})
}

// 产品列表--发货
export function apiShipmentOrderExWarehouse(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/ex_warehouse",
		method: "post",
		data
	})
}
export function apiDpkCbrSubmitted(data = {}) {
	return instance({
		url: "/aim/api/v3/aipc/dpk/cbr/submitted",
		method: "post",
		data
	})
}
export function apiDpkCbrCompleted(data = {}) {
	return instance({
		url: "/aim/api/v3/aipc/dpk/cbr/completed",
		method: "post",
		data
	})
}


// 产品列表--移除产品
export function apiShipmentOrderRemoveDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/remove_device",
		method: "post",
		data
	})
}

// 产品列表--清空产品
export function apiShipClearDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/clear_devices",
		method: "post",
		data
	})
}

// 添加包装工单
export function apiShipmentOrderAddCartonOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/add_carton_order",
		method: "post",
		data
	})
}

// 移除包装工单
export function apiShipmentOrderRemoveCartonOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/shipment_order/remove_carton_order",
		method: "post",
		data
	})
}
//按发货单回传数据
export function apiDeviceForShipmentOrderUpsert(data = {}) {
	return instance({
		url: "/aim/api/v3/amap/upsert_batch",
		method: "post",
		data
	})
}
//按发货单下载数据
export function apiDowloadShipmentOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/amap/dowload_shipmentOrder",
		method: "post",
		data
	})
}